import React, { useState } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import FeatherIcon from 'feather-icons-react';
import { Button, Dropdown, Modal } from 'react-bootstrap';

export const tableColumns: ColumnDef<any>[] = [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row: { original } }) => {
      const { name, id } = original;
      return (
        <div className="d-flex align-items-center">
          <div>{name}</div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 border-start border-end border-translucent ps-0'
      },
      cellProps: {
        className:
          'ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    accessorKey: 'fpAddress',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <span>Address</span>
          <div className="px-1 py-1 bg-success-subtle rounded me-2">
            <FeatherIcon icon="mail" size={16} className="text-success-dark" />
          </div>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { fpAddress } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fw-semibold">{fpAddress}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'createdAt',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <span>Created at</span>
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon
              icon="calendar"
              size={16}
              className="text-primary-dark"
            />
          </div>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { createdAt } = original;
      return <>{createdAt}</>;
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'isActive',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <span>Status</span>
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon
              icon="check-circle"
              size={16}
              className="text-primary-dark"
            />
          </div>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { isActive } = original;
      return (
        <>
          {isActive ? (
            <span className="badge bg-success">Active</span>
          ) : (
            <span className="badge bg-secondary">Inactive</span>
          )}
        </>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    id: 'actions',
    header: () => {
      return (
        <div className="d-flex align-items-centerr">
          <span>Action</span>
        </div>
      );
    },
    cell: ({ row: { original }, table }: any) => {
      const { makeActive } = table.options.meta;
      const [showMarkActiveModal, setShowMarkActiveModal] = useState(false);
      const handleMarkActiveModal = (show: boolean) =>
        setShowMarkActiveModal(show);
      const handleClose = () => setShowMarkActiveModal(false);

      return (
        <>
          <RevealDropdownTrigger>
            <RevealDropdown>
              <Dropdown.Item onClick={() => handleMarkActiveModal(true)}>
                Mark Active
              </Dropdown.Item>
              <Dropdown.Item className="text-danger">Remove</Dropdown.Item>
            </RevealDropdown>
          </RevealDropdownTrigger>

          <Modal
            show={showMarkActiveModal}
            onHide={() => handleMarkActiveModal(false)}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header>
              <Modal.Title>Are you sure?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to activate this wallet?
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  handleMarkActiveModal(false);
                }}
              >
                Close
              </Button>
              <Button
                variant="primary"
                onClick={() => {
                  (makeActive(original.id), handleMarkActiveModal(false));
                }}
              >
                Yes, I'm sure
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      },
      cellProps: {
        className: 'text-end border-end pe-4 ps-4 border-translucent'
      }
    }
  }
];

const FeePayerWalletTable = () => {
  return (
    <div className="border-top border-translucent">
      <AdvanceTable
        tableProps={{ className: 'phoenix-table fs-9' }}
        rowClassName="hover-actions-trigger btn-reveal-trigger"
      />
      <AdvanceTableFooter pagination className="py-4" />
    </div>
  );
};

export default FeePayerWalletTable;
